import { render, staticRenderFns } from "./StatBtn.vue?vue&type=template&id=04e9a355&"
import script from "./StatBtn.vue?vue&type=script&lang=ts&"
export * from "./StatBtn.vue?vue&type=script&lang=ts&"
import style0 from "./StatBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
